module.exports = __webpack_public_path__ + "img/006.f181fe63.png";